module.exports = __webpack_public_path__ + "img/1f37e.8e7a139.svg";